import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {ConsentUseCaseContainerComponent} from './container/consent-use-case-container.component';
import {ConsentUseCaseReducer} from './store';
import {ConsentUseCaseEffects} from './store/consent-use-case-effects';

const routes: Routes = [
    {path: '', component: ConsentUseCaseContainerComponent}
]

@NgModule({
    declarations: [
        ConsentUseCaseContainerComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(ConsentUseCaseReducer.REDUCER_NAME, ConsentUseCaseReducer.consentChapterReducer),
        EffectsModule.forFeature([ConsentUseCaseEffects]),
        CommonModule
    ],
    exports: [
        ConsentUseCaseContainerComponent
    ]
})
export class ConsentUseCaseModule { }
